/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Suja",
  logo_name: "mohammed.suja()",
  nickname: "suja",
  full_name: "Mohammed Suja",
  subTitle:
    "A hard working, Detail oriented, methodical professional and self motivated Mobile Application Developer",
  resumeLink:
    "https://drive.google.com/file/d/1tKnVan6-gkTDaPeQ1IB_2VdWDDOWVg9P/view?usp=sharing",
  mail: "mailto:mohamedsuja7n@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/MohamedSuja",
  linkedin: "https://www.linkedin.com/in/mohamed-suja-1ab988198/",
  gmail: "moahamedsuja7n@gmail.com",
  gitlab: " ",
  facebook: " ",
  twitter: " ",
  instagram: " ",
};

const skills = {
  data: [
    {
      title: "Ios & Android Mobile Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Experience working with React Native CLI and Expo",
        "⚡ Publishing apps on the App Store & Play Store using Appcenter & Eas",
        "⚡ Experience with 20+ Projects",
        "⚡ Experience working with TypeScript and JavaScript",
        "⚡ Experience working iOS and Android Platforms",
        "⚡ Experience working with Redux",
      ],
      softwareSkills: [
        {
          skillName: "React Native CLI",
          fontAwesomeClassname: "skill-icons:react-light",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Expo",
          fontAwesomeClassname: "logos:expo",
          style: {
            width: "80px",
          },
        },

        {
          skillName: "TypeScript",
          fontAwesomeClassname: "skill-icons:typescript",
          style: {},
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Redux Toolkit",
          fontAwesomeClassname: "skill-icons:redux",
          style: {},
        },
        {
          skillName: "Jest Testing",
          fontAwesomeClassname: "logos:jest",
          style: {},
        },

        {
          skillName: "Styled Components",
          fontAwesomeClassname: "skill-icons:styledcomponents",
          style: {},
        },
        {
          skillName: "Tailwindcss",
          fontAwesomeClassname: "devicon:tailwindcss",
          style: {},
        },
        {
          skillName: "iOS App Development",
          fontAwesomeClassname: "raphael:ios",
          style: {
            color: "#9da1a8",
          },
        },
        {
          skillName: "Android App Development",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
      ],
    },

    {
      title: "Backend Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Experience working with Firebase and Firestore",
        "⚡ Experience working with REST APIs",
      ],
      softwareSkills: [
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs",
          style: {},
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "devicon:express",
          style: {},
        },
        {
          skillName: "NestJS",
          fontAwesomeClassname: "logos:nestjs",
          style: {},
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
      ],
    },
    {
      title: "Frontend Development",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experience working with ReactJS and NextJS",
        "⚡ Experience working with TypeScript and JavaScript",
        "⚡ Experience working with Redux",
        "⚡ Experience working with Tailwindcss",
        "⚡ Experience working with Styled Components",
        "⚡ Experience working with HTML and CSS",
        "⚡ Successfully delivered 10+ Wordpress Freelancing Projects",
      ],
      softwareSkills: [
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "Tailwindcss",
          fontAwesomeClassname: "devicon:tailwindcss",
          style: {},
        },
        {
          skillName: "Styled Components",
          fontAwesomeClassname: "skill-icons:styledcomponents",
          style: {},
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS4",
          fontAwesomeClassname: "akar-icons:css-fill",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
      ],
    },
    {
      title: "Version Control & Deployment",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working with Git Version Control System",
        "⚡ Experience working with Docker",
        "⚡ Experience working with cPanel",
        "⚡ Experience working with hosting on Godaddy and Hostinger",
      ],
      softwareSkills: [
        {
          skillName: "GitHub",
          fontAwesomeClassname: "akar-icons:github-fill",
          style: {
            color: "#000",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "devicon:gitlab",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Godaddy",
          fontAwesomeClassname: "simple-icons:godaddy",
          style: {
            color: "#2EDCDA",
          },
        },
        {
          skillName: "cPanel",
          fontAwesomeClassname: "logos:cpanel",
          style: {
            width: "80px",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sabaragamuwa University of Sri Lanka",
      subtitle: "BSc (Hons) Computing & Information Systems",
      logo_path: "susl.png",
      alt_name: "SUSL",
      duration: "2018 - 2023",
      descriptions: [
        "⚡ Studied Advanced Software Development Concepts, Data Management & Warehousing",
        "⚡ Learn Advanced Topics in Cloud Computing, Cloud Architecture along with Serverless Computing",
        "⚡ Worked on projects on courses like Mobile Computing and Web Technologies.",
      ],
      website_link: "https://www.sab.ac.lk/computing/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Explore App Development with the MERN Stack",
      subtitle: "Node.js .React.js . Express.js . MongoDB",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/2767ad344dcc6a4f06b2a9518d6ddc799b84f34a54ffd35508b79f85ff2540bb?trk=backfilled_certificate",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Become a React Native Developer",
      subtitle: "React Native Cross-platform Development",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/f3eb7e58447184da0e66834748428ccbf6758ed65e2de784efbf73d38ed0a922?trk=backfilled_certificate&lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Create a CRM Mobile Application with React Native",
      subtitle: "React Native . Customer Relationship Management (CRM)",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/11051aed6205be9ed01242bd18a5d65f081d7312ebf60f86cd4b0fd949010c66?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "From React to React Native",
      subtitle: "React Native",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/2781dba94a5d9cf3293ddeec681dabcc99aa38dafb7cf7185e59b0ec0a0e20bd?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },

    {
      title: "Learning React Native",
      subtitle: "React Native",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/25471577326374a537127a0dd3de3f207efa7f97e90aa9e440959c8cc4903627?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BvgtD17EZTKaD7KM0WluzIw%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "React Native Ecosystem and Workflow",
      subtitle: "React Native . Cross-platform Development",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/ab5f57157cd7f70da1ad1cb26f314bf14aaaca0f6ff8c923064f6741b3623341?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bh0PthWNcR%2BCOmsBZCMSiMQ%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "React Native Essential Training",
      subtitle: "React Native",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/08945b3665780650eac14742e2f1da4899d5a0a6b9073b05fbe5a6942bada997?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bh0PthWNcR%2BCOmsBZCMSiMQ%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Building RESTful APIs with Node.js and Express (2019)",
      subtitle: "Node.js . Express.js . REST APIs",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/fb97f0b23aa0e0a9d0379e5719a0b3a53787cc3aac64035121ee8b6c3034e334?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Building a Website with Node.js and Express.js",
      subtitle: "Node.js . Express.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/f804685cbac4109cc88c90a1860b3668139ea221516ae32b0ec00ca3e3cbccea?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },

    {
      title: "Express Essentials: Build Powerful Web Apps with Node.js",
      subtitle: "Express.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/92d50b63e865034200dd488c6492cd1d4d661be4f170cf12997d1aa52312fca2?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },

    {
      title:
        "Learning Full-Stack JavaScript Development: MongoDB, Node, and React (2016)",
      subtitle: "Node.js . MongoDB .  React.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/3eb19c0a0c2553976ca3809e8c555a5d62bffef3af510c930b8d447d0da77b5b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: " Learning MongoDB",
      subtitle: "MongoDB",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/5d4dce3bd6bbe5ff788ce9fbc51de25dea222711048283ee4751627b7b13793a?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },

    {
      title: "Learning npm the Node Package Manager (2018)",
      subtitle: "Node.js . npm",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/add96dd029827bc40688be8788ae0c2f5e3ef55b1477338b1e797cbcbc190160?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BvgtD17EZTKaD7KM0WluzIw%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Node.js Essential Training",
      subtitle: "Node.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/bdcd67d22058678a021e917c969a8e990102182dd079a894247bb2e490c88305?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BvgtD17EZTKaD7KM0WluzIw%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Node.js: Securing RESTful APIs",
      subtitle: "Node.js . REST APIs",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/0718aaee9864e5051161dbcc9acff288717722d93468455ee5c660f4182d4451?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BvgtD17EZTKaD7KM0WluzIw%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Node.js: Security",
      subtitle: "Node.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/dcc51b4bf9c1eb8f16798d096997e35d7592191c8daded713203f953205063c0?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bh0PthWNcR%2BCOmsBZCMSiMQ%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },

    {
      title: "React.js Essential Training",
      subtitle: "React.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/248445e0759b6822f3dc3efcc22c93e2afdd61124df2d0a23f116f426b7f4b2b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bh0PthWNcR%2BCOmsBZCMSiMQ%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "React: Design Patterns",
      subtitle: "React.js . Software Design Patterns",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/dcbaf66c597c74f46b267e34b3eba22eea9a77cee5cd0edbd0fd2a0fdf7bc6c0?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3Bh0PthWNcR%2BCOmsBZCMSiMQ%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "React: Securing Applications",
      subtitle: "React.js . Secure Authentication",
      logo_path: "linkedin.png",
      certificate_link: "",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
    {
      title: "Node.js: Testing and Code Quality",
      subtitle: "Node.js",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/0abe1fb546c9fdf7e2aff2b0ca4a47fe2a4c98115cd8c4d1d9969ab1690e299f?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BfSAs1SZrTdOUgCdTEsXq0w%3D%3D",
      alt_name: "linkdin",
      color_code: "#ffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I possess 1.5 years of hands-on experience in mobile application development, with a strong focus on React Native. During this period, I have successfully contributed to the creation and enhancement of cross platform mobile applications. \n\n  My experience has equipped me with the skills and knowledge necessary to develop mobile applications that meet both user requirements and industry standards. I am enthusiastic about leveraging my expertise to contribute to future mobile app development projects.",
  header_image_path: "experience.svg",

  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "Codelantic Pvt Ltd",
          company_url: "https://sugarlabs.org/",
          logo_path: "codelantic.png",
          duration: "Mar 2024 - Present",
          location: "Colombo - 06, Sri Lanka",
          description:
            "Skills: Mobile Application Development · React Native · TypeScript · JavaScript · CI/CD · Fatlane · HIPAA · Git · Agile · Scrum · Jira · Confluence",
          color: "#ee3c26",
        },
        {
          title: "Associate Software Engineer",
          company: "Codelantic Pvt Ltd",
          company_url: "https://sugarlabs.org/",
          logo_path: "codelantic.png",
          duration: "Mar 2023 - Mar 2024",
          location: "Colombo - 06, Sri Lanka",
          description:
            "Skills: Mobile Application Development · React Native · TypeScript · JavaScript · CI/CD · Git · Agile · Scrum · Jira · Confluence",
          color: "#ee3c26",
        },
      ],
    },

    {
      title: "Internships",
      experiences: [
        {
          title: "Trainee Software Engineer",
          company: "Codelantic Pvt Ltd",
          company_url: "https://sugarlabs.org/",
          logo_path: "codelantic.png",
          duration: "Sep 2022 - Feb 2023",
          location: "Colombo - 06, Sri Lanka",
          description:
            "Skills: Mobile Application Development · React Native · TypeScript · JavaScript",
          color: "#ee3c26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "suja.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try my best to write a blog about it.",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "RestaurantX",
      url:
        "https://play.google.com/store/apps/details?id=com.foodlober.codelantic",
      description:
        "RestaurantX, designed exclusively for the restaurant industry. Our specialized platform is #tailored just for restaurants ",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "devicon-typescript",
        },
        {
          name: "Redux Toolkit",
          iconifyClass: "skill-icons:redux",
        },
        {
          name: "Jest Testing",
          iconifyClass: "logos:jest",
        },
        {
          name: "iOS",
          iconifyClass: "raphael:ios",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
        {
          name: "Google Cloud",
          iconifyClass: "logos-google-cloud",
        },
      ],
    },
    {
      name: "SpotOn Money",
      url:
        "https://play.google.com/store/apps/details?id=com.spoton.spotonmoney",
      description: "SpotonMoney is a FINTEC based mobile banking application",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "devicon-typescript",
        },
        {
          name: "Redux Toolkit",
          iconifyClass: "skill-icons:redux",
        },
        {
          name: "Jest Testing",
          iconifyClass: "logos:jest",
        },
        {
          name: "iOS",
          iconifyClass: "raphael:ios",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
      ],
    },
    {
      name: "SaloonX",
      url:
        "https://play.google.com/store/apps/details?id=com.codelantic.styloo",
      description:
        "The salon management system is a salon reservation system where the users can log into the system and reserve the service",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "devicon-typescript",
        },
        {
          name: "Redux Toolkit",
          iconifyClass: "skill-icons:redux",
        },
        {
          name: "Jest Testing",
          iconifyClass: "logos:jest",
        },
        {
          name: "iOS",
          iconifyClass: "raphael:ios",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
      ],
    },
    {
      name: "Satellite Trading",
      url:
        "https://play.google.com/store/apps/details?id=com.codelantic.styloo",
      description:
        "The Satellite Trading Mobile Application is a mobile application that allows users to buy and sell products online",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "devicon-typescript",
        },
        {
          name: "Redux Toolkit",
          iconifyClass: "skill-icons:redux",
        },
        {
          name: "Jest Testing",
          iconifyClass: "logos:jest",
        },
        {
          name: "iOS",
          iconifyClass: "raphael:ios",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
      ],
    },
    {
      name: "FBM Smart Cleaning Mobile Application",
      url: "",
      description:
        "The cleaning solution is an online platform where clients can sign up to have cleaning chores completed by our qualified cleaners and then have the cleaning inspected by inspectors.",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "devicon-typescript",
        },
        {
          name: "Redux Toolkit",
          iconifyClass: "skill-icons:redux",
        },
        {
          name: "Jest Testing",
          iconifyClass: "logos:jest",
        },
        {
          name: "iOS",
          iconifyClass: "raphael:ios",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
      ],
    },
    {
      name: "Emergency Application",
      url: "https://github.com/MohamedSuja/PoliceEmergencyApp",
      description:
        "The Emergency Mobile Application can indeed be a business solution for police departments and the public.",
      languages: [
        {
          name: "React Native",
          iconifyClass: "logos-react",
        },
        {
          name: "JavaScript",
          iconifyClass: "devicon-javascript",
        },
        {
          name: "Firebase",
          iconifyClass: "logos:firebase",
        },
        {
          name: "Android",
          iconifyClass: "simple-icons:android",
        },
      ],
    },
    {
      name: "Attend Application",
      url:
        "https://play.google.com/store/apps/details?id=com.suja_apps.attend2app",
      description:
        "The Attend application system can indeed be a useful tool for managing university student attendance percentages.",
      languages: [
        {
          name: "Flutter",
          iconifyClass: "skill-icons:flutter-light",
        },
        {
          name: "SQLite",
          iconifyClass: "devicon:sqlite",
        },
      ],
    },
    {
      name: "Three Level Password Authentication System",
      url:
        "https://github.com/MohamedSuja/Three-Level-Password-Authentication-System",
      description:
        "A Three Level Password Authentication System can be a useful tool for protecting employees' personal information in a particular organization.",
      languages: [
        {
          name: "JavaFx",
          iconifyClass: "devicon:java",
        },
        {
          name: "SQLite",
          iconifyClass: "devicon:sqlite",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
